import { Injectable } from "@angular/core";
import { InterventionTableDefinitionFactory } from "../../model/InterventionTableDefinitionFactory";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class RawDataInterventionAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: InterventionTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
